module.exports = __webpack_public_path__ + "img/18_61.8a653151.png";